type PromiseResolver<T> = (value: T | PromiseLike<T>) => void

export const createPromise = <T>(): [Promise<T>, PromiseResolver<T>] => {
    let resolver = (value: T | PromiseLike<T>) => {};

    return [
        new Promise<T>((resolve) => {
            resolver = resolve
        }),
        resolver
    ]
}